import styled from 'styled-components';

export const LoanPaidOffWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const Text = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #6d7184;

  /* Less than 375px */
  @media (max-width: ${(props) => props.theme.breakpoint.sm}px) {
    word-break: break-word;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    margin-bottom: 4px;
  }
`;
